import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import './theme.css';
import './app.css';

/**
 * Point d'entrée de l'application.
 *
 * `client/index.html` pointe ici. Il y a eu, entre le 23 et le 25/08/2026, un
 * aiguillage (`src/boot.tsx`) qui choisissait entre cette interface et celle,
 * sombre, qui l'a précédée : le temps de valider la direction. Les deux sont
 * partis une fois le choix fait — une bascule qui ne bascule plus vers rien
 * n'est que du code à maintenir.
 *
 * L'ancienne interface reste dans l'historique git, au commit `9ed9919`.
 */
const container = document.getElementById('root');

if (container === null) {
  throw new Error('Élément #root introuvable dans index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
